import type { ExtractPropTypes, PropType } from 'vue'

export const paginationsProps = {
  /**
   * 总条目数
   */
  total: {
    type: Number,
    required: true
  },
  /**
   * 当前页码
   */
  currentPage: {
    type: Number,
    default: 1
  },
  /**
   * 每页显示条目个数
   */
  pageSize: {
    type: Number,
    default: 10
  },
  /**
   * 页码按钮的数量，当总页数超过该值时会折叠
   */
  pagerCount: {
    type: Number,
    default: 7
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 是否显示每页条数选择器
   */
  showSizeChanger: {
    type: Boolean,
    default: true
  },
  /**
   * 每页显示个数选择器的选项设置
   */
  pageSizes: {
    type: Array as PropType<number[]>,
    default: () => [10, 20, 30, 40, 50]
  },
  /**
   * 是否显示快速跳转
   */
  showQuickJumper: {
    type: Boolean,
    default: false
  },
  /**
   * 是否显示总条目数
   */
  showTotal: {
    type: Boolean,
    default: true
  }
} as const

export type PaginationsProps = Partial<ExtractPropTypes<typeof paginationsProps>>

export const paginationsEmits = {
  'update:currentPage': (page: number) => typeof page === 'number',
  'update:pageSize': (size: number) => typeof size === 'number',
  change: (page: number, pageSize: number) => true,
  'size-change': (size: number) => typeof size === 'number'
}

export type PaginationsEmits = typeof paginationsEmits
